// removed by extract-text-webpack-plugin
module.exports = {"list":"_3C8VUqRgNje34znOvuPoqk","listItemIcon":"j5z50j48deVBVTbKtjT5F","hasDropdown":"_2tuxKFqZmjU2zxyEbAFTcd","linkTitle":"_2-ooHU1XqlFdGZ2yolRDxW","dropdownTitle":"kaDCYWwIuwWXzsU_jkyZI","showTextOnPhone":"_32K0GSHIRIFYFc4_mJFMwv","showIconOnPhone":"_1Jo7vmhwih3xQtx786WbLs","dropdownContent":"_2G9BWU5lJ7JFrUj05fJROo","arrow":"_3YK0CAC1X3V1pjJ3XKsWEq","listThemeDefault":"boph4-nbdMZBIwE4-dcAx","listThemePrimary":"_1wHLTuJ5XZgcug_b6rXm9h","listThemeDark":"_1Fp4fpjl3N36I-kipRiN2w"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/01-molecules/navigation/primary-navigation.scss
// module id = 107
// module chunks = 0